import { type CommandFilters, basisValue, filtered, needsAttention, tourRows } from './logic';
import type { CommandDeparture, Severity } from './types';

/** Action and attention select tours. Keep every scoped departure of each qualifying tour. */
export function toursLocalRows(
  data: CommandDeparture[],
  filters: CommandFilters,
  today: Date,
  attention: 'red' | 'amber' | 'empty' | Severity | null,
  period: { from: string; to: string } | null,
  omit: 'region' | 'tourId' | 'action' | 'confidenceTier',
) {
  const scope = {
    ...filters,
    ...(omit === 'region' ? { region: 'All' } : {}),
    ...(omit === 'tourId' ? { tourId: null } : {}),
    ...(omit === 'confidenceTier' ? { confidenceTier: [] } : {}),
    action: 'all' as const,
  };
  const rows = filtered(data, scope, today).filter((d) => !period || (d.dep >= period.from && d.dep <= period.to));
  return tourRows(rows, rows, filters.basis, [])
    .filter(
      (tour) =>
        (omit === 'action' ||
          !filters.action ||
          filters.action === 'all' ||
          tour.rows.some((d) => basisValue(d, 'flag', filters.basis) === filters.action)) &&
        (!filters.onlyAttention || (attention ? tour[attention] > 0 : needsAttention(tour))),
    )
    .flatMap((tour) => tour.rows);
}
